export var TaskName;
(function (TaskName) {
    TaskName["CheckAbandonedBotsTask"] = "CheckAbandonedBotsTask";
    TaskName["FileScanTask"] = "FileScanTask";
    TaskName["SendMailTask"] = "SendMailTask";
    TaskName["MultisessionDetectTask"] = "MultisessionDetectTask";
    TaskName["ResolveReplyAction"] = "ResolveReplyAction";
    TaskName["SendBulkTemplateMessagesTask"] = "SendBulkTemplateMessagesTask";
    /** Added just for consistency, but this if functionality to be removed soon */
    TaskName["UnsubscribedTemporaryWebhook"] = "UnsubscribedTemporaryWebhook";
    TaskName["ExportTask"] = "ExportTask";
})(TaskName || (TaskName = {}));
